<template>
	<a
		class="site_button_tertiary"
		:class="[theme, type]"
		:href="parsedLink ? parsedLink.url : null"
		:target="parsedLink.target ? parsedLink.target : (target ? target : (type === 'resource' ? '_blank' : null))"
		@mouseenter="hovered = true"
		@mouseleave="hovered = false"
		ref="site_button_tertiary"
		:download="type === 'file'"
	>
		<video-icon
			class="video_icon"
			v-if="type === 'video'"
		></video-icon>

		<chevron-left v-if="type === 'back'"></chevron-left>

		<span v-html="button_label ? button_label : parsedLink.title"></span>

		<chevron-right v-if="parsedLink.target != '_blank' && type != 'back'"></chevron-right>

		<resource-link
			v-if="type === 'file'"
			class='resource'
		></resource-link>

		<external-link
			class="external_link_icon"
			v-if="
        parsedLink.target === '_blank' ||
        button_link.target === '_blank' ||
        target === '_blank'
      "
		></external-link>

	</a>
</template>

<script>
import ChevronLeft from './ChevronLeft.vue';
import ChevronRight from './ChevronRight.vue';
import ExternalLink from './ExternalLink.vue';
import ResourceLink from './ResourceLink.vue';
import VideoIcon from './VideoIcon.vue';
export default {
	data() {
		return {
			button_label: this.label,
			button_link: this.link,
			hovered: false,
		};
	},

	props: {
		link: {},
		label: {},
		target: {},
		theme: {},
		type: {
			default: 'normal',
		},
	},

	computed: {
		parsedLink() {
			if (typeof this.link === 'object' && this.link !== null) {
				return this.link;
			} else if (!Array.isArray(this.link)) {
				try {
					return JSON.parse(this.link);
				} catch (e) {
					return null;
				}
			} else {
				return null;
			}
		},
	},

	watch: {
		link() {
			this.button_link = this.link;
		},
	},

	methods: {
		checkEmpty(e) {
			if (this.button_link.url === '#') {
				// this.$refs.site_button_tertiary.removeAttribute('href');
				e.preventDefault();
			}
		},
	},

	components: {
		ExternalLink,
		VideoIcon,
		ResourceLink,
		ChevronRight,
		ChevronLeft,
	},

	created() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.site_button_tertiary {
	display: inline-flex;
	padding: 0;
	background: transparent;
	text-decoration: none;
	/* height: 32px; */
	display: inline-flex;
	justify-content: center;
	align-items: center;
	transition: 0.2s ease all;
	color: var(--fpe-blue);
	background: transparent;

	&.reverse {
		background: transparent;
		color: var(--white);

		span {
			color: var(--white);
		}

		&::v-deep {
			svg {
				path {
					fill: var(--white);
				}
			}
		}

		@media (hover) {
			&:hover {
				cursor: pointer;
				text-decoration: underline;
			}
		}
	}

	&.current {
		background: var(--fpe-blue);
		transition: 0.2s ease all;
		cursor: pointer;
		color: var(--white);
	}

	.video_icon {
		margin-right: 7px;
	}

	.external_link_icon {
		margin-left: 8px;

		line,
		path {
			stroke: var(--white);
			transition: 0.2s ease all;

			g {
				stroke: var(--white);
				transition: 0.2s ease all;
			}
		}

		/* .theme--blue & {
			line,
			path {
				stroke: var(--fpe-blue);
				transition: 0.2s ease all;

				g {
					stroke: var(--fpe-blue);
					transition: 0.2s ease all;
				}
			}
		} */
	}

	.resource {
		margin-left: 8px;
		width: 16px;
		height: 16px;

		line,
		path {
			fill: var(--fpe-blue);
			transition: 0.2s ease all;

			g {
				fill: var(--fpe-blue);
				transition: 0.2s ease all;
			}
		}
	}

	@media (hover) {
		&:hover {
			cursor: pointer;
			text-decoration: underline;
		}
	}

	&:disabled {
		opacity: 0.5;
	}

	span {
		font: normal normal 600 15px/18px var(--primary-font-family);
		color: var(--fpe-blue);
		margin-right: 0;
		position: relative;
		z-index: 10;
	}

	svg {
		display: flex;
		max-width: 24px;
		max-height: 12px;
		margin-left: 8px;
	}

	&.back {
		svg {
			display: flex;
			max-width: 24px;
			max-height: 12px;
			margin-right: 8px;
			margin-left: 0;
		}
	}

	.theme--dark_blue &,
	.theme--blue & {
		color: var(--white);

		span {
			color: var(--white);
		}

		svg {
			&::v-deep {
				path {
					fill: var(--white);
				}
			}
		}
	}

	.theme--rose &,
	.theme--emerald & {
		color: var(--fpe-blue);

		span {
			color: var(--fpe-blue);
		}

		svg {
			&::v-deep {
				path {
					fill: var(--fpe-blue);
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/TertiaryButton.vue